<kv-loyalty-account-balance-filter *ngIf="readyPermission"
  (onApply)="onSearch($event)"
  [customerMgPermission]="customerMgPermission"
  [movementExportExcelPermission]="movementExportExcelPermission"
></kv-loyalty-account-balance-filter>

<div class="ui-g ui-g-12"  *ngIf="readyPermission">
  <!-- Tabella normale -->
  <app-loyalty-account-balance-table
    *ngIf="searchPressed && !customerMgPermission"
    [movements]="movements"
    [customerIdforExport]="customerIdforExport"
    [movementExportExcelPermission]="movementExportExcelPermission"
  >
  </app-loyalty-account-balance-table>
  <!-- Tabella Gabrielli -->
  <app-loyalty-account-balance-table-mg
    *ngIf="searchPressed && customerMgPermission"
    [movements]="movements"
    [actualBalance]="actualBalance"
  >
  </app-loyalty-account-balance-table-mg>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-account-balance/loyalty-account-balance.component.html